import { Fab } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
 
export default function BackButton({ navigate, navigateTo, navState, onBack }) {
  return (
    <Fab
      onClick={() => {
        if (onBack) {
          onBack();
        } else if (navigateTo) {
          navigate(navigateTo, navState ? { state: navState } : undefined);
        } else {
          navigate(-1);
        }
      }}
      size="small"
      aria-label="back"
      title="Back"
    >
      <KeyboardArrowLeftRounded />
    </Fab>
  );
}